<template>
  <fieldset>
    <el-divider>Email Options</el-divider>
    <div class="row mb-30 col-sm-6 checkbox-container">
      <el-checkbox
        id="doNotSendTransactionalEmails"
        v-model="modelValue.doNotSendTransactionalEmails"
      >
        Do Not Send Email
      </el-checkbox>
      <div class="help-block">
        Note that if this option is enabled, the user will not get any transactional emails!
      </div>
    </div>

    <div
      class="row mb-0"
      :class="{ 'disabled-container': modelValue.doNotSendTransactionalEmails }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="addPaymentSourceEmail"
          v-model="modelValue.addPaymentSourceEmail"
        >
          Add Payment Source Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="updatePaymentSourceEmail"
          v-model="modelValue.updatePaymentSourceEmail"
        >
          Update Payment Source Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="defaultPaymentSourceEmail"
          v-model="modelValue.defaultPaymentSourceEmail"
        >
          Default Payment Source Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="deletePaymentSourceEmail"
          v-model="modelValue.deletePaymentSourceEmail"
        >
          Delete Payment Source Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="apologyRefundEmail"
          v-model="modelValue.apologyRefundEmail"
        >
          Apology Refund Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="blockDriverEmail"
          v-model="modelValue.blockDriverEmail"
        >
          Block Driver Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="cancellationFeeDisputeSuccessEmail"
          v-model="modelValue.cancellationFeeDisputeSuccessEmail"
        >
          Cancellation Fee Dispute SuccessEmail
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="cancellationFeeDisputeFailedEmail"
          v-model="modelValue.cancellationFeeDisputeFailedEmail"
        >
          Cancellation Fee Dispute Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="closingAccountEmail"
          v-model="modelValue.closingAccountEmail"
        >
          Closing Account Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="falseTripDisputeFailedEmail"
          v-model="modelValue.falseTripDisputeFailedEmail"
        >
          False Trip Dispute Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="falseTripDisputeSuccessEmail"
          v-model="modelValue.falseTripDisputeSuccessEmail"
        >
          False Trip Dispute Success Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="fareDisputeSuccessEmail"
          v-model="modelValue.fareDisputeSuccessEmail"
        >
          Fare Dispute SuccessEmail
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="fareDisputeFailedEmail"
          v-model="modelValue.fareDisputeFailedEmail"
        >
          Fare Dispute Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="findLostItemFailedEmail"
          v-model="modelValue.findLostItemFailedEmail"
        >
          Find Lost Item Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="refundEmail"
          v-model="modelValue.refundEmail"
        >
          Refund Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="giftCardNotificationEmail"
          v-model="modelValue.giftCardNotificationEmail"
        >
          Gift Card Notification Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="giftCardReceiptEmail"
          v-model="modelValue.giftCardReceiptEmail"
        >
          Gift Card Receipt Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipRenewalReminderEmail"
          v-model="modelValue.membershipRenewalReminderEmail"
        >
          Membership Renewal Reminder Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipConfirmationEmail"
          v-model="modelValue.membershipConfirmationEmail"
        >
          Membership Confirmation Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipFailedEmail"
          v-model="modelValue.membershipFailedEmail"
        >
          Membership Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipReceiptEmail"
          v-model="modelValue.membershipReceiptEmail"
        >
          Membership Receipt Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipTrialConfirmationEmail"
          v-model="modelValue.membershipTrialConfirmationEmail"
        >
          Membership Trial Confirmation Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipTrialWillEndEmail"
          v-model="modelValue.membershipTrialWillEndEmail"
        >
          Membership Trial Will End Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="gogoGourmetReceiptEmail"
          v-model="modelValue.gogoGourmetReceiptEmail"
        >
          GoGo Gourmet Receipt Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="needLoveRefundEmail"
          v-model="modelValue.needLoveRefundEmail"
        >
          Need Love Refund Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="newRideCreditsNotificationEmail"
          v-model="modelValue.newRideCreditsNotificationEmail"
        >
          New GoGo Credits Notification Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="noPaymentMethodOnFileEmail"
          v-model="modelValue.noPaymentMethodOnFileEmail"
        >
          No Payment Method On File Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="noRidesCallerEmail"
          v-model="modelValue.noRidesCallerEmail"
        >
          No Rides Caller Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="noShowReceiptEmail"
          v-model="modelValue.noShowReceiptEmail"
        >
          No Show Receipt Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="partnerCreditsNotificationEmail"
          v-model="modelValue.partnerCreditsNotificationEmail"
        >
          Partner Credits Notification Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="partnerRidesNotificationEmail"
          v-model="modelValue.partnerRidesNotificationEmail"
        >
          Partner Rides Notification Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="refundRideEmail"
          v-model="modelValue.refundRideEmail"
        >
          Refund Ride Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="rideCancellationReceiptEmail"
          v-model="modelValue.rideCancellationReceiptEmail"
        >
          Ride Cancellation Receipt Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="rideCreditsRenewalEmail"
          v-model="modelValue.rideCreditsRenewalEmail"
        >
          GoGo Credits Renewal Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="rideHistoryEmail"
          v-model="modelValue.rideHistoryEmail"
        >
          Ride History Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="rideReceiptEmail"
          v-model="modelValue.rideReceiptEmail"
        >
          Ride Receipt Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideCancelledEmail"
          v-model="modelValue.scheduledRideCancelledEmail"
        >
          Scheduled Ride Cancelled Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideChangedEmail"
          v-model="modelValue.scheduledRideChangedEmail"
        >
          Scheduled Ride Changed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideConfirmedEmail"
          v-model="modelValue.scheduledRideConfirmedEmail"
        >
          Scheduled Ride Confirmed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideReminderDayBeforeEmail"
          v-model="modelValue.scheduledRideReminderDayBeforeEmail"
        >
          Scheduled Ride Reminder Day Before Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideUnpaidServicesEmail"
          v-model="modelValue.scheduledRideUnpaidServicesEmail"
        >
          Scheduled Ride Unpaid Services Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRidePreauthFailedEmail"
          v-model="modelValue.scheduledRidePreauthFailedEmail"
        >
          Scheduled Ride Preauthorization Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryCanceledEmail"
          v-model="modelValue.scheduledGroceryCanceledEmail"
        >
          Scheduled Grocery Canceled Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryChangedEmail"
          v-model="modelValue.scheduledGroceryChangedEmail"
        >
          Scheduled Grocery Changed mail
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryConfirmedEmail"
          v-model="modelValue.scheduledGroceryConfirmedEmail"
        >
          Scheduled Grocery Confirmed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryReminderEmail"
          v-model="modelValue.scheduledGroceryReminderEmail"
        >
          Scheduled Grocery Reminder Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryUnpaidServicesEmail"
          v-model="modelValue.scheduledGroceryUnpaidServicesEmail"
        >
          Scheduled Grocery Unpaid Services Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryPreauthFailedEmail"
          v-model="modelValue.scheduledGroceryPreauthFailedEmail"
        >
          Scheduled Grocery Preauth Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledDeliveryReminderEmail"
          v-model="modelValue.scheduledDeliveryReminderEmail"
        >
          Scheduled Delivery Reminder Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledDeliveryUnpaidServicesEmail"
          v-model="modelValue.scheduledDeliveryUnpaidServicesEmail"
        >
          Scheduled Delivery Unpaid Services Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledDeliveryPreauthFailedEmail"
          v-model="modelValue.scheduledDeliveryPreauthFailedEmail"
        >
          Scheduled Delivery Preauth Failed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="surgePricingWasConfirmedEmail"
          v-model="modelValue.surgePricingWasConfirmedEmail"
        >
          Surge Pricing Was Confirmed Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="welcomeEmail"
          v-model="modelValue.welcomeEmail"
        >
          Welcome Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="welcomeEmailForUsersWithPartners"
          v-model="modelValue.welcomeEmailForUsersWithPartners"
        >
          Welcome Email For Users With Partners
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="deactivationPassedAwayEmail"
          v-model="modelValue.deactivationPassedAwayEmail"
        >
          Deactivation Passed Away Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="suspendingAccountMembershipEmail"
          v-model="modelValue.suspendingAccountMembershipEmail"
        >
          Suspending Account Membership Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryReceiptEmail"
          v-model="modelValue.groceryReceiptEmail"
        >
          Grocery Receipt Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryReceivedEmail"
          v-model="modelValue.groceryReceivedEmail"
        >
          Grocery Received Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderReminderEmail"
          v-model="modelValue.groceryOrderReminderEmail"
        >
          Grocery Order Reminder Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="refundDepositDeniedEmail"
          v-model="modelValue.refundDepositDeniedEmail"
        >
          Refund Deposit Denied Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="accountReactivateEmail"
          v-model="modelValue.accountReactivateEmail"
        >
          Account Reactivate Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="driverCanceledEmail"
          v-model="modelValue.driverCanceledEmail"
        >
          Driver Canceled Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="freeTrialReminderEmail"
          v-model="modelValue.freeTrialReminderEmail"
        >
          Free Trial Reminder Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderUpdateEmail"
          v-model="modelValue.groceryOrderUpdateEmail"
        >
          Grocery Order Update Email
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="homeServicesReceiptEmail"
          v-model="modelValue.homeServicesReceiptEmail"
        >
          Home Services Receipt Email
        </el-checkbox>
      </div>
    </div>

    <div class="row mt-30 mb-30">
      <div class="col-sm-6 checkbox-container">
        <el-checkbox
          id="doNotSendMarketingEmails"
          v-model="modelValue.doNotSendMarketingEmails"
        >
          Do not send me marketing emails
        </el-checkbox>
        <div class="help-block">
          Note that if this option is enabled, the user will not get any marketing emails!
        </div>
      </div>
    </div>

    <div
      class="row mb-0"
      :class="{ 'disabled-container': modelValue.doNotSendMarketingEmails }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationCampaignEmail"
          v-model="modelValue.crmActivationCampaignEmail"
        >
          CRM Activation Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationHardRegistrationCampaignEmail"
          v-model="modelValue.crmActivationHardRegistrationCampaignEmail"
        >
          CRM Activation Hard Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmMomentumEngagementCampaignEmail"
          v-model="modelValue.crmMomentumEngagementCampaignEmail"
        >
          CRM Momentum/Engagement Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmReactivationCampaignEmail"
          v-model="modelValue.crmReactivationCampaignEmail"
        >
          CRM Reactivation Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmRevivalCampaignEmail"
          v-model="modelValue.crmRevivalCampaignEmail"
        >
          CRM Revival Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmResurrectionCampaignEmail"
          v-model="modelValue.crmResurrectionCampaignEmail"
        >
          CRM Resurrection Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmCrossSellGourmetCampaignEmail"
          v-model="modelValue.crmCrossSellGourmetCampaignEmail"
        >
          CRM Cross Sell Gourmet Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmCrossSellGroceriesCampaignEmail"
          v-model="modelValue.crmCrossSellGroceriesCampaignEmail"
        >
          CRM Cross Sell Groceries Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmCrossSellHomeServicesCampaignEmail"
          v-model="modelValue.crmCrossSellHomeServicesCampaignEmail"
        >
          CRM Cross Sell Home Services Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationDormantSoftRegistrationCampaignEmail"
          v-model="modelValue.crmActivationDormantSoftRegistrationCampaignEmail"
        >
          CRM Activation Dormant Soft Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationDormantHardRegistrationCampaignEmail"
          v-model="modelValue.crmActivationDormantHardRegistrationCampaignEmail"
        >
          CRM Activation Dormant Hard Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserAddedCCRegistrationEmail"
          v-model="modelValue.crmActivationNewUserAddedCCRegistrationEmail"
        >
          CRM Activation New User Added CC Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserGroceryRegistrationEmail"
          v-model="modelValue.crmActivationNewUserGroceryRegistrationEmail"
        >
          CRM Activation New User Grocery Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserGourmetRegistrationEmail"
          v-model="modelValue.crmActivationNewUserGourmetRegistrationEmail"
        >
          CRM Activation New User Gourmet Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserOnlineRegistrationEmail"
          v-model="modelValue.crmActivationNewUserOnlineRegistrationEmail"
        >
          CRM Activation New User Online Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserPhoneRegistrationEmail"
          v-model="modelValue.crmActivationNewUserPhoneRegistrationEmail"
        >
          CRM Activation New User Phone Registration Campaign
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="crmActivationNewUserPickedPlanRegistrationEmail"
          v-model="modelValue.crmActivationNewUserPickedPlanRegistrationEmail"
        >
          CRM Activation New User Picked Plan Registration Campaign
        </el-checkbox>
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});
</script>
